import { AfterViewInit, Component, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { FormsService } from '../../../services/forms.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentService } from '../../../services/document.service';


export interface DocumentData {
    id: string;
    createdById: string;
    createdByName: string;
    contentBase64: string,
    contentType: string,
    createdDate: string;
    description: boolean;
    folderName: string;
    typeName: string
    extension: string;
    fileName: string;
    fileSize: string;
    shortUrl: string;
    expireDate: string;
}



@Component({
  selector: 'app-shared-documents',
  templateUrl: './shared-documents.component.html',
  styleUrls: ['./shared-documents.component.scss']
})
export class SharedDocumentsComponent implements AfterViewInit {


    displayedColumns: string[] = ['form'];
    dataSource: MatTableDataSource<DocumentData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    documents: Array<DocumentData> = [];

    pagecode: string = "user-shared-documents";
    module: string = "home";
    accessdenied: boolean = false;
    isLoading: boolean = true;
    loadingMessage: string = "Loading...";

    constructor(private authentication: AuthenticationService, private route: ActivatedRoute, private _router: Router, private _commonService: CommonService, private _documentsService: DocumentService, private _formsService: FormsService) {
        window.scroll(0, 0);
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        //this.getUserForms(1);
                        this.getUserDocuments(1);

                    }
                    else {
                        this.accessdenied = true;
                        this.isLoading = false;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                    this.isLoading = false;
                }
            );
        });

    }
    splitText(text: any): string {
        if (text.length > 50)
            return text.substring(0, 50) + "...";
        else
            return text;
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    formCategories: any = [
        {
            "name": "All",
            "code": "all",
            "isActive": true,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        },
        {
            "name": "Sales",
            "code": "Sales",
            "isActive": false,
            "active_background_color": "green",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "green"
        },
        {
            "name": "Services",
            "code": "Services",
            "isActive": false,
            "active_background_color": "orange",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "orange"
        },
        {
            "name": "Support",
            "code": "Support",
            "isActive": false,
            "active_background_color": "red",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "red"
        },
        {
            "name": "Admin",
            "code": "Admin",
            "isActive": false,
            "active_background_color": "blue",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "blue"
        },
        {
            "name": "Development",
            "code": "Development",
            "isActive": false,
            "active_background_color": "black",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "black"
        },
        {
            "name": "Other",
            "code": "other",
            "isActive": false,
            "active_background_color": "grey",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "grey"
        }

    ];
    applyCategoryFilter(categoryCode: any) {
        debugger;
        if (categoryCode === 'all') {
            this.dataSource = new MatTableDataSource(this.documents);
        }
        else {
            var filteredArray: DocumentData[] = this.documents.filter(s => s.folderName.toLowerCase().includes(categoryCode.toLowerCase()));
            this.dataSource = new MatTableDataSource(filteredArray);
        }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        for (var i = 0; i < this.formCategories.length; i++) {
            if (this.formCategories[i].code === categoryCode)
                this.formCategories[i].isActive = true;
            else
                this.formCategories[i].isActive = false;
        }

    }
    openDocument(id: any) {
        this._router.navigate(['home/document/' + id]);
    }

    getUserDocuments(page: any) {
        this._documentsService.getUserDocuments(page, this.authentication._authentication.userName).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        console.log("getUserDocuments", page, res);
                        for (var i = 0; i < res.data.length; i++) {
                            this.documents.push({
                                contentBase64: res.data[i].file.contentBase64,
                                contentType: res.data[i].file.contentType,
                                createdById: res.data[i].file.createdUser.id,
                                createdByName: res.data[i].file.createdUser.firstName + ' ' + res.data[i].file.createdUser.lastName,
                                createdDate: res.data[i].file.createdDate,
                                description: res.data[i].file.description,
                                extension: res.data[i].file.fileExtension,
                                fileName: res.data[i].file.fileName,
                                fileSize: res.data[i].file.fileSize,
                                folderName: res.data[i].file.documentCenterFolder.folderName,
                                id: res.data[i].file.id,
                                shortUrl: res.data[i].file.shortUrl,
                                typeName: res.data[i].file.documentType.type,
                                expireDate : res.data[i].file.expireDate
                            });
                        }

                        this.dataSource = new MatTableDataSource(this.documents);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                        this.loadingMessage = "No data found";

                        if (res.data.length > 0)
                            this.getUserDocuments(page + 1);
                        else
                            this.isLoading = false;
                    }
                }
            },
            (err: any) => {
                console.error("Web/Forms/getUserForms()", err);
            }
        );

    }

}


